function percentualRound(value) {
  value = Math.round(value * 1000) / 1000;
  value = (Math.round(value * 100) / 100) === value
    ? value
    : parseFloat(value.toString().slice(0, -1));

  return value;
}

module.exports = percentualRound;
